import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {MaterialSupplierOffersPage} from "./-page/material-supplier-offers.page";
import {MaterialOffersPending} from "./-page/material-offers.pending";
import {listSupplierOffersSearchSchema} from "@project/application/engineering/supplier-offers";
import {Route as MaterialRoute} from "../route";

export const Route = createFileRoute("/_app/engineering/materials/$materialId/offers/")({
  component: RouteComponent,
  pendingComponent: MaterialOffersPending,
  staticData: {meta: {labelDescriptor: routeMessages.offers}},
  validateSearch: (search) => listSupplierOffersSearchSchema.parse(search),
});

function RouteComponent() {
  const {materialId} = useParams({strict: false}) as {materialId: string};

  const {includeDeleted} = MaterialRoute.useSearch();
  return <MaterialSupplierOffersPage materialId={materialId} includeDeleted={includeDeleted} />;
}
